module.exports = __webpack_public_path__ + "8e6e2c724515335b5c868de88111828f.svg";